import { handleErrors } from './ErrorActions';
import * as successActions from './SuccessActions';
import * as submitMasterSetupRecordApi from '../api/submit-master-setup-record';
import { getUserHasManageRights } from '../api/user-data';
import { FORM_KEYS } from '../form-designer/constants/form-manager.constants';
import * as selectors from '../selectors/MasterSetupPageSelectors';
import { isEmpty } from '../utils/ramdaUtils';

export const MASTER_SETUP_PAGE_SET_PARAMETERS = 'MASTER_SETUP_PAGE_SET_PARAMETERS';
export const MASTER_SETUP_PAGE_OPEN_DELETE_MODAL = 'MASTER_SETUP_PAGE_OPEN_DELETE_MODAL';
export const MASTER_SETUP_PAGE_CLOSE_DELETE_MODAL = 'MASTER_SETUP_PAGE_CLOSE_DELETE_MODAL';
export const MASTER_SETUP_PAGE_SAVE_RECORD = 'MASTER_SETUP_PAGE_SAVE_RECORD';
export const MASTER_SETUP_PAGE_SAVE_RECORD_SUCCESS = 'MASTER_SETUP_PAGE_SAVE_RECORD_SUCCESS';
export const MASTER_SETUP_PAGE_SAVE_RECORD_FAILURE = 'MASTER_SETUP_PAGE_SAVE_RECORD_FAILURE';
export const MASTER_SETUP_PAGE_DELETE_RECORD = 'MASTER_SETUP_PAGE_DELETE_RECORD';
export const MASTER_SETUP_PAGE_DELETE_RECORD_SUCCESS = 'MASTER_SETUP_PAGE_DELETE_RECORD_SUCCESS';
export const MASTER_SETUP_PAGE_DELETE_RECORD_FAILURE = 'MASTER_SETUP_PAGE_DELETE_RECORD_FAILURE';
export const MASTER_SETUP_PAGE_SET_MANAGE_RIGHTS = 'MASTER_SETUP_PAGE_SET_MANAGE_RIGHTS';

export const setParameters = (entityName, searchName) => ({
  type: MASTER_SETUP_PAGE_SET_PARAMETERS,
  entityName,
  searchName,
});

export const openDeleteModal = () => ({
  type: MASTER_SETUP_PAGE_OPEN_DELETE_MODAL,
});

export const closeDeleteModal = () => ({
  type: MASTER_SETUP_PAGE_CLOSE_DELETE_MODAL,
});

export const saveRecordSuccess = (message) => (dispatch) => {
  dispatch({
    type: MASTER_SETUP_PAGE_SAVE_RECORD_SUCCESS,
  });
  dispatch(successActions.addSuccess({ message }));
};

export const saveRecordFailure = (errors = []) => (dispatch) => {
  dispatch({
    type: MASTER_SETUP_PAGE_SAVE_RECORD_FAILURE,
  });
  if (!isEmpty(errors)) {
    dispatch(handleErrors(errors));
  }
};

export const saveRecord = (commandName = '', commandArgument = '') => async (
  dispatch,
  getState
) => {
  if (getState().warnings.some((w) => w.preventsFormSubmission)) {
    return;
  }

  dispatch({
    type: MASTER_SETUP_PAGE_SAVE_RECORD,
  });

  const state = getState();

  const { entityName, itemId, clientChanges } = selectors.getSaveParameters(state, {
    formKey: FORM_KEYS.STEP,
  });
  const recordSaveSuccessTranslation = selectors.getRecordSaveSuccessTranslation(state);

  try {
    const response = await submitMasterSetupRecordApi.saveMasterSetupRecord(
      clientChanges,
      entityName,
      itemId,
      commandName,
      commandArgument
    );
    if (response.hasError) {
      dispatch(saveRecordFailure(response.errors));
      return;
    }
  } catch (error) {
    dispatch(saveRecordFailure([{ errorMessage: error.message }]));
    return;
  }

  dispatch(saveRecordSuccess(recordSaveSuccessTranslation));
};

export const deleteRecordSuccess = (message) => (dispatch) => {
  dispatch(closeDeleteModal());
  dispatch({
    type: MASTER_SETUP_PAGE_DELETE_RECORD_SUCCESS,
  });
  dispatch(successActions.addSuccess({ message }));
};

export const deleteRecordFailure = (errors = []) => (dispatch) => {
  dispatch(closeDeleteModal());
  dispatch({
    type: MASTER_SETUP_PAGE_DELETE_RECORD_FAILURE,
  });
  if (!isEmpty(errors)) {
    dispatch(handleErrors(errors));
  }
};

export const deleteRecord = () => async (dispatch, getState) => {
  dispatch({
    type: MASTER_SETUP_PAGE_DELETE_RECORD,
  });

  const state = getState();
  const { entityName, itemId } = selectors.getDeleteParameters(state);
  const recordDeleteSuccessTranslation = selectors.getRecordDeleteSuccessTranslation(state);

  try {
    const response = await submitMasterSetupRecordApi.deleteMasterSetupRecord(entityName, itemId);
    if (response.hasError) {
      dispatch(deleteRecordFailure(response.errors));
      return;
    }
  } catch (error) {
    dispatch(deleteRecordFailure([{ errorMessage: error.message }]));
    return;
  }

  dispatch(deleteRecordSuccess(recordDeleteSuccessTranslation));
};

const setManageRights = (entityName, hasRight) => ({
  type: MASTER_SETUP_PAGE_SET_MANAGE_RIGHTS,
  payload: { entityName, hasRight },
});

export const fetchUserHasManageRights = (entityName) => async (dispatch, getState) => {
  const {
    masterSetupPage: { manageRights },
  } = getState();

  if (entityName in manageRights) {
    return;
  }

  const { hasmanagerights, hasError, errors } = await getUserHasManageRights(entityName);

  if (hasError) {
    dispatch(handleErrors(errors));
    return;
  }

  dispatch(setManageRights(entityName, hasmanagerights));
};
